// src/pages/LoginPage.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';


function LoginPage() {
    const [cedula, setCedula] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const {login} = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://kifli-api.onrender.com/api/login', {
            
            //const response = await fetch('http://localhost:5000/api/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ cedula, password }),
            });

            const data = await response.json();

            if (response.ok) {
                login(data.user);
                navigate('/');
            }else{
                alert(data.message);
            }
        } catch (error) {
            console.error('Error al iniciar sesión:', error);
            alert('Error de conexión con el servidor.');
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center py-12 px-4">
            <div className="max-w-md w-full space-y-8 bg-[#292929] p-10 rounded-xl shadow-lg">
                <div>
                    <h2 className="text-center text-4xl font-bold text-white">
                        Iniciar Sesión
                    </h2>
                </div>
                <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                    <input name="cedula" type="tel" maxLength="10" required value={cedula} onChange={(e) => setCedula(e.target.value)} className="input-field bg-[#222222] px-4" placeholder="Cédula" />
                    <input name="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-field bg-[#222222] px-4" placeholder="Contraseña" />
                    
                    <div className="flex items-center justify-end">
                        <div className="text-sm">
                            <Link to="/olvide-contrasena" className="font-medium text-lime-400 hover:text-lime-300">
                                ¿Olvidaste tu contraseña?
                            </Link>
                        </div>
                    </div>

                    <button type="submit" className="form-button bg-lime-400 text-black hover:bg-white hover:text-lime-400">
                        Ingresar
                    </button>
                </form>
            </div>
        </div>
    );
}

export default LoginPage;
